import { Button } from 'reactstrap';
import styled from 'styled-components';

const SmallLinkButton = styled(Button)`
   font-size: .7em;
`;

export default SmallLinkButton;